import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";


export const affiliatesEarning = createAsyncThunk(
    "affiliates/affiliatesEarning",
    async ({ token }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/affiliates/revenue`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data.status) {
                return response.data;
            } else {
                return rejectWithValue({ message: "Failed to fetch earnings" });
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: "Unknown error" });
        }
    }
);

export const fetchAffiliates = createAsyncThunk(
    "affiliates/fetchAffiliates",
    async ({ token, offset = 1, limit = 15 }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/affiliates/list`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        offset,
                        limit
                    }
                }
            );
            if (response.data.status) {
                return { offset, response: response.data.response };
            } else {
                return rejectWithValue({ message: "Failed to fetch affiliates" });
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: "Unknown error" });
        }
    }
);

const initialState = {
    totalEarning: 0,
    list: [],
    loading: false,
};

const affiliatedSlice = createSlice({
    name: 'affiliated',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAffiliates.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAffiliates.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload.response || [];
            })
            .addCase(fetchAffiliates.rejected, (state, action) => {
                state.loading = false;
               
            })
            .addCase(affiliatesEarning.pending, (state) => {
                state.loading = true;
            })
            .addCase(affiliatesEarning.fulfilled, (state, action) => {
                state.loading = false;
                state.totalEarning = action.payload.response;
            })
            .addCase(affiliatesEarning.rejected, (state, action) => {
                state.loading = false;
                state.totalEarning = 0;
               
            });
    },
});

export default affiliatedSlice.reducer;
